import { MultiSelect } from "@tql/ui-components-react/tql/dropdowns";

import type { Accessorial } from "~/shared/schemas/accessorial-schema";
import type { SubGroupKey } from "~/shared/types/quote-details-types";
import { capitalizeWord } from "~/shared/utils/string-fns.ts";

import styles from "./service-options-mobile.module.css";

const SERVICE_DISPLAY_NAMES: Record<string, string> = {
	"Delivery Call Ahead": "Call Ahead",
};

type ServiceOptionsMobileProps = Readonly<{
	name: SubGroupKey;
	serviceOptions: Accessorial[];
	isOptionSelected: (option: Accessorial) => boolean;
	isOptionDisabled: (option: Accessorial) => boolean;
	handleCombinedSelectionChange: (
		option: Accessorial,
		checked: boolean,
	) => void;
}>;

export function ServiceOptionsMobile({
	name,
	serviceOptions,
	isOptionSelected,
	isOptionDisabled,
	handleCombinedSelectionChange,
}: ServiceOptionsMobileProps) {
	// itemRender isn't available on the TQL MultiSelect, so disabled options are simply left out of the list.
	const data = serviceOptions
		.filter((option) => !isOptionDisabled(option))
		.map((option) => ({
			...option,
			name: SERVICE_DISPLAY_NAMES[option.name] ?? option.name,
		}));
	const value = data.filter((option) => isOptionSelected(option));

	const handleChange = (event: { value: Accessorial[] }) => {
		const nextSelectedIds = new Set(event.value.map((option) => option.id));
		for (const option of serviceOptions) {
			const shouldBeSelected = nextSelectedIds.has(option.id);
			if (shouldBeSelected !== isOptionSelected(option)) {
				handleCombinedSelectionChange(option, shouldBeSelected);
			}
		}
	};

	return (
		<div
			className={styles.serviceOptionsMobileWrapper}
			data-testid={`${name}-service-options-mobile`}
		>
			<div className={styles.serviceOptionsMobileTitle}>
				{capitalizeWord(name)} Services
			</div>
			<MultiSelect
				data={data}
				dataItemKey={"id"}
				onChange={handleChange}
				tagLimit={3}
				tagLimitShowAllByDefault={true}
				textField={"name"}
				value={value}
			/>
		</div>
	);
}
